function _isRegExp(x) {
  return Object.prototype.toString.call(x) === '[object RegExp]';
}
module.exports = _isRegExp;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isRegExp.js
// module id = 1363
// module chunks = 0